// extracted by mini-css-extract-plugin
module.exports = {"StoresPage":"StoresPage_StoresPage__1zIUl","container":"StoresPage_container__3QU7E","storesList":"StoresPage_storesList__1luOy"};